import { styles } from "@repo/helpers";
import { SortTypeEnum } from "@repo/models";
import { Column, DateColumn, GridPreLoaded } from "@repo/ui";
import { useCallback, useMemo } from "react";

import type { Complaint } from "../../../../models";

import style from "../../../../components/duplicateRepModal/style.module.scss";

interface Props {
	complaint: Complaint;
	duplicates: Complaint[];
}

export function PotentialDuplicatesGrid(props: Props) {
	const { complaint, duplicates } = props;

	const getColumn = useCallback(
		(name: string, propertyName: keyof Complaint, formatFn?: (r: Complaint) => string) => {
			const column = new Column<Complaint>(name, propertyName).withFullObject();
			return boldSameValue(column);

			function boldSameValue(column: Column<Complaint>) {
				const { propertyName } = column;
				const getProp = (c: Complaint) => c[propertyName] as string;
				const getPropUpper = (c: Complaint) => getProp(c)?.toUpperCase();
				return column.withFormat((r) => {
					const p1 = getPropUpper(r);
					const p2 = getPropUpper(complaint);
					const className = styles(p1 && p1 === p2 && style.duplicateColumn);
					const innards = formatFn ? formatFn(r) : getProp(r);
					return <span className={className}>{innards}</span>;
				});
			}
		},
		[complaint],
	);

	const columns = useMemo(
		() =>
			[
				new DateColumn("Incident Date", "incidentDate").dateOnly().withSortBy(SortTypeEnum.descending),
				new Column("Customer Name", "customerName"),
				getColumn("Account Number", "customerAccountNumber"),
				getColumn("Customer Phone Number", "customerPhoneNumber"),
				getColumn("ESID", "esidNumber"),
				new Column("Complaint Type", "complaintTypeDescription"),
				new Column("Incident Source", "complaintSourceDescription"),
			] as Column<Complaint>[],
		[getColumn],
	);

	return (
		<GridPreLoaded
			id="potDuplicatesGrid"
			columns={columns}
			keyProperty="complaintId"
			values={duplicates}
			loading={false}
			canSetItemsPerPage={false}
		/>
	);
}
